<template>
	<div>
		<v-badge
			v-if="!showChat"
			bordered
			color="error"
			:content="notified"
			:value="notified"
			overlap
			class="open-button"
		>
			<v-btn fab color="info" @click="open">
				<v-icon>mdi-forum</v-icon>
			</v-btn>
		</v-badge>
		<v-btn v-else fab color="info" absolute class="open-button" @click="showChat = false">
			<v-icon>mdi-close</v-icon>
		</v-btn>
		<v-sheet
			v-if="showChat"
			id="myForm"
			class="chat-popup rounded-tr-xl"
			:style="!isMobile ? 'max-width: 350px;' : 'width: auto'"
			style="z-index: 4"
		>
			<div>
				<messages
					:id="idPerson"
					:adminProfile="adminProfile"
					:sender="sender"
					:conversations="person.conversation"
					:receiver="person.idCompany"
				/>
			</div>
		</v-sheet>
	</div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Pusher from 'pusher-js';

export default {
	props: {
		sender: {
			type: String,
			default: '',
		},
		idPerson: {
			type: String,
			default: '',
		},
	},
	components: {
		Messages: () => import('@/components/persons/Messages'),
	},
	data() {
		return {
			showChat: false,
			pusher: null,
		};
	},
	computed: {
		...mapGetters({
			notified: 'Person/notified',
			person: 'Person/person',
			adminProfile: 'User/profileUser',
		}),
	},
	created() {
		this.pusher = new Pusher(process.env.VUE_APP_PUSHER_KEY, {
			cluster: process.env.VUE_APP_PUSHER_CLUSTER,
		});
		this.pusher.connection.bind('update', function(err) {
			console.error(err);
		});
		this.channel = this.pusher.subscribe('person');
		this.channel.bind('update', data => this.$emit('updatePerson', data));
		this.$on('updatePerson', async data => {
			if (data.idPerson === this.person._id && data.idSender !== this.userProfile._id) {
				await this.getPerson(data.idPerson);
				if (this.showChat && this.notified) this.updateNofitified();
			}
		});
	},
	methods: {
		async updateNofitified() {
			if (this.notified) {
				await this.updateConversation({
					id: this.person._id,
					payload: { read: true, receiver: this.userProfile._id },
				});
			}
		},
		open() {
			this.showChat = true;
			this.updateNofitified();
		},
		...mapActions({
			updateConversation: 'Person/updateConversation',
			getPerson: 'Person/getPerson',
		}),
	},
};
</script>

<style lang="scss" scoped>
.v-application ul {
	padding-left: 0 !important;
}
.open-button {
	opacity: 0.8;
	position: fixed;
	bottom: 23px;
	right: 28px;
	z-index: 1;
}

/* The popup chat - hidden by default */
.chat-popup {
	position: fixed;
	bottom: 80px;
	right: 15px;
	border-radius: 0 0 0 25px;
	z-index: 2;
}

/* Add styles to the form container */
.form-container {
	max-width: 300px;
	padding: 10px;
	background-color: white;
}

/* Full-width textarea */
.form-container textarea {
	width: 100%;
	padding: 15px;
	margin: 5px 0 22px 0;
	border: none;
	background: #f1f1f1;
	resize: none;
	min-height: 200px;
}

/* When the textarea gets focus, do something */
.form-container textarea:focus {
	background-color: #ddd;
	outline: none;
}

/* Set a style for the submit/send button */
.form-container .btn {
	background-color: #4caf50;
	color: white;
	padding: 16px 20px;
	border: none;
	cursor: pointer;
	width: 100%;
	margin-bottom: 10px;
	opacity: 0.8;
}

/* Add some hover effects to buttons */
.form-container .btn:hover,
.open-button:hover {
	opacity: 1;
}
</style>
